<template>
	<div class="owl-carousel">
		<div class="item" v-for="item in items" :style="`background-image: url(${item.img})`">
      <img :src="`${item.img}`" alt="">
		</div>
	</div>
</template>

<script>
module.exports = {

	props: ['items'],

	data () {
		return {}
	},

	updated() {
		this.$emit('updated', {
			owlSettings: {
				items: 1,
				loop: this.items.length > 1 ? true : false,
				nav: true
			}
		});
	}
}
</script>

<style lang="scss">
@import "scss/wanted";
.global-slider-container {
	.slider-aboutSlider {
    @include l_up{
      height: 360px;
    }
    margin-top: 54px;
		overflow: hidden;

		.owl-carousel {
			.item {
        background-size: cover;
        @media (max-width: 1179px){
          background: none!important;
        }
        @include l_up{
          height: 360px;
          img{
            display: none;
          }
        }
			}
		}

    .owl-nav{
			.owl-next, .owl-prev{
        position: absolute;
  			top: calc(50% - 22px);
				width: 44px;
				height: 44px;
				font-size: 0;
				background-color: #fff;
				border: 1px solid rgb(244, 244, 245);
				background-image: url('../img/slArr.png');
				background-position: center;
				background-repeat: no-repeat;
				border-radius: 100%;
				@include single-transition();
        box-shadow: 0px 1px 4px 0px rgba(242, 242, 242, 0.004);

        &.owl-next{
          right: -22px;
        }
				&.owl-prev{
					transform: rotate(180deg);
          left: -22px;
				}
				&:hover{
					background-color: #006eb6;
					border-color: #006eb6;
					filter: brightness(100%);
					background-image: url('../img/slArr2.png');
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// aboutSlider.vue?5c586de7